module.exports = __webpack_public_path__ + "static/media/minus.e1806b3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/minus.svg
// module id = 245
// module chunks = 0